export { MediaSlider, type MediaSliderProps } from "./MediaSlider";
